import { useLazyQuery } from "@apollo/client";
import { SERVICE_STATUS } from "./service-status.query";

export const useServiceStatus = () => {
  const [getServicesStatus, { data, loading, error }] =useLazyQuery(SERVICE_STATUS);

  const getServiceStatus = (serviceName: string) => {
    getServicesStatus({
      variables: {
        serviceName,
      },
      fetchPolicy: "network-only",
      nextFetchPolicy: "network-only",
    });
  };

  return {
    getServiceStatus,
    data: data?.getServiceStatus,
    loading,
    error,
  };
};
